import { faSearch } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "src/base-components/Icon";
import { FeatureQueryConversationContextContextTypeEnum } from "src/clients/copilot";
import { NODE_TYPE } from "src/constants/NodeTypes";
import { ResourceType } from "src/copilot/utils";

const Suggestion: React.FC<{
  prompt: string;
  onClick: (prompt: string) => void;
}> = ({ prompt, onClick }) => {
  return (
    <button
      className="flex h-32 w-36 appearance-none flex-col items-start gap-y-2 rounded-lg border border-gray-200 bg-gray-50 p-3 text-left font-inter-normal-12px"
      onClick={() => onClick(prompt)}
    >
      <Icon color="text-gray-500" icon={faSearch} size="xs" />
      <p className="text-gray-800">{prompt}</p>
    </button>
  );
};

const getSuggestions = (
  nodeType?: NODE_TYPE,
  resourceType?: ResourceType, // Replace with the actual context type when we have it
): string[] => {
  if (
    resourceType ===
    FeatureQueryConversationContextContextTypeEnum.FEATURE_QUERY
  ) {
    return [
      "Calculate the total transaction amount in the last 30 days by card",
      "Calculate the total transaction amount in the last 60 days by card",
      "Calculate the average transaction amount in the last 90 days by card",
    ];
  }
  if (nodeType === NODE_TYPE.SQL_DATABASE_CONNECTION_NODE) {
    return [
      "Show me which tables are available",
      "Relevant tables for credit underwriting",
      "Check if applicant is blacklisted",
    ];
  }
  return [
    "Calculate the applicant's age from their birth date",
    "Explain what this node does",
    "Refactor this node to simplify it's logic",
  ];
};

export const EmptyState: React.FC<{
  onPromptClick: (prompt: string) => void;
  nodeType?: NODE_TYPE;
  resourceType?: ResourceType;
}> = ({ onPromptClick, nodeType, resourceType }) => {
  const suggestions = getSuggestions(nodeType, resourceType);
  return (
    <div className="flex h-full flex-grow flex-col items-center justify-center gap-x-2 gap-y-3 p-2">
      <p className="font-inter-normal-12px text-gray-500">Some ideas...</p>
      <div className="flex items-center gap-x-2">
        {suggestions.map((suggestion, index) => (
          <Suggestion
            // It might look unlikely that the same suggestion is shown twice, but it's possible. Hence in that event we add the index.
            key={suggestion + index}
            prompt={suggestion}
            onClick={onPromptClick}
          />
        ))}
      </div>
    </div>
  );
};
